module.exports = __webpack_public_path__ + "media/images/main_events/2024/icon-arrow-5adf0b9047d4fe8f9024bb63298ca064.svg";